/**
 * Created by Administrator on 2017/10/16.
 * 注册所有组件
 */
// 组件
// 公用组件
// 导航
import Navigator from '../widget/Navigator.vue';
// loading
import Loading from '../widget/Loading.vue'
//  备用
import DSError from '../widget/DSError.vue'
import CpAlertView from '../widget/CpAlertView.vue'
// footer导航
import FooterNavigator from '../widget/FooterNavigator.vue'
// PC
// tab
import NavPageView from '@/components/computer/home/NavPageView.vue';
// 标题
import TitlePageView from '@/widget/computer/TitlePageView.vue';
import BannerPageView from '@/widget/computer/BannerPageView.vue';
// 底栏
import FooterPageView from '@/widget/computer/FooterPageView.vue'
// APP
// nav
import AppNavPageView from '@/widget/app/AppNavPageView.vue';
// 标题
import AppTitlePageView from '@/widget/app/AppTitlePageView.vue';
import AppBannerView from '@/widget/app/AppBannerView.vue';
// 底栏
import AppFooterPage from '@/widget/app/AppFooterPage.vue';
class ComponentConfig {
  static createComponent(vue) {
    vue.component('navigator', Navigator);
    vue.component('loading', Loading);
  //  备用
    vue.component('DSError', DSError);
    vue.component('cp-alert-view', CpAlertView);
    vue.component('footer-navigator', FooterNavigator);
    vue.component('nav-page-view', NavPageView);
    vue.component('title-page-view', TitlePageView);
    vue.component('banner-page-view', BannerPageView);
    vue.component('footer-page-view', FooterPageView);
    vue.component('app-nav-page-view', AppNavPageView);
    vue.component('app-title-page-view', AppTitlePageView);
    vue.component('app-banner-view', AppBannerView);
    vue.component('app-footer-page', AppFooterPage);
  }
}

export default ComponentConfig;
